app.filter('schoolCategoryString', function () {
    return function (input) {
    	if (input === 0) {
    		return "1. - 3. klasse";
    	}
    	if (input === 1) {
    		return "4. - 6. klasse";
    	}
    	if (input === 2) {
    		return "7. - 10. klasse";
    	} else if (input === 3) {
		return "Ungdomsuddannelser";
	}
    	return "Ukendt";
    }
});
